import { Component, Input, ElementRef, ViewChild, OnInit, OnDestroy, TemplateRef, AfterViewInit, OnChanges, SimpleChanges, SecurityContext } from '@angular/core';
import { DemographicChartHelper, Demographics, DemographicType } from '../../../classes/demographics';
import { PreRenderService } from '../../../services/pre-render.service';
import { TranslateService } from '@ngx-translate/core';
import { SCREEN_SIZE } from '../../../classes/enums';
import { DomSanitizer } from '@angular/platform-browser';
declare var Chart: any;

@Component({
  selector: 'app-demographic-item',
  templateUrl: './demographic-item.component.html',
  styleUrls: [
    './demographic-item.component.scss',
  ],
})
export class DemographicItemComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  @Input() demographics: Demographics;
  @Input() maintainAspectRatio: boolean = false;
  @Input() itemTemplate: TemplateRef<any>;
  @Input() chartConfig: Chart.ChartConfiguration;
  @Input() screenSize: SCREEN_SIZE = SCREEN_SIZE.DESKTOP_UP;
  shouldHideLegend: boolean = false;
  @ViewChild('canvasRef') canvasRef: ElementRef;
  @ViewChild('chartLegendsRef') chartLegendsRef: ElementRef;
  chart: any;

  @Input() demographicType: DemographicType;

  constructor(private prerenderService: PreRenderService,
    private translateService: TranslateService,
    private domSanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.checkShouldHideLegend();
  }

  checkShouldHideLegend() {
    this.shouldHideLegend = (this.screenSize >= SCREEN_SIZE.DESKTOP_UP &&
      this.demographicType === 'income' ||
      this.demographicType === 'family-composition') ||
      this.demographicType === 'population-age' || this.demographicType === 'mother-tongue';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.prerenderService.isBrowserMode) {
      if (changes.screenSize && changes.screenSize.previousValue) {
        this.checkShouldHideLegend();
        setTimeout(() => {
          this.getChartConfig();
          this.chart.update(this.chartConfig);
        });
      }
    }
  }

  ngAfterViewInit() {
    if (this.prerenderService.isBrowserMode) {
      this.getChartConfig();
      this.initCharts();
    }
  }

  initCharts() {
    if (this.chartConfig) {
      const canvas = this.canvasRef.nativeElement as HTMLCanvasElement;
      const context = canvas.getContext('2d');
      this.chartConfig.options.maintainAspectRatio = this.maintainAspectRatio;
      if (this.screenSize >= SCREEN_SIZE.TABLET_PORTRAIT_UP) {
        Chart.defaults.global.defaultFontSize = '16';
      } else {
        Chart.defaults.global.defaultFontSize = '10';
      }
      Chart.defaults.global.defaultFontFamily = 'Roboto';
      Chart.defaults.global.defaultFontColor = 'black';
      Chart.defaults.global.defaultFontStyle = 'normal';

      this.chart = new Chart(context, this.chartConfig);
      if (this.chart && this.chart.generateLegend && this.chartLegendsRef) {
        this.chartLegendsRef.nativeElement.innerHTML = this.chart.generateLegend();
      }
    }
  }

  ngOnDestroy() {
    if (this.prerenderService.isBrowserMode) {
      if (this.chart && this.chart.destroy) {
        this.chart.destroy();
      }
    }
  }

  getChartConfig() {
    switch (this.demographicType) {
      case 'income': {
        this.chartConfig = DemographicChartHelper.getHouseholdIncomeChartConfig(this.demographics, this.translateService, this.screenSize);
        break;
      }
      case 'tenancy': {
        this.chartConfig = DemographicChartHelper.getTenancyChartConfig(this.demographics, this.translateService, this.screenSize);
        break;
      }
      case 'housing-type': {
        this.chartConfig = DemographicChartHelper.getHousingTypeChartConfig(this.demographics, this.translateService, this.screenSize);
        break;
      }
      case 'population-age': {
        this.chartConfig = DemographicChartHelper.getPopulationAgeChartConfig(this.demographics, this.translateService, this.screenSize);
        break;
      }
      case 'mother-tongue': {
        this.chartConfig = DemographicChartHelper.getMotherTongueChartConfig(this.demographics, this.translateService, this.screenSize);
        break;
      }
      case 'commute-mode': {
        this.chartConfig = DemographicChartHelper.getCommuteModeChartConfig(this.demographics, this.translateService, this.screenSize);
        break;
      }
      case 'education': {
        this.chartConfig = DemographicChartHelper.getEducationChartConfig(this.demographics, this.translateService, this.screenSize);
        break;
      }
      case 'family-composition': {
        this.chartConfig = DemographicChartHelper.getFamilyCompositionChartConfig(this.demographics, this.translateService, this.screenSize);
        break;
      }
    }
  }
}
